// Détection d'aéroport / transport — UI helpers uniquement.
//
// La résolution lat/lng → mode (drive/fly) + aéroport est faite côté serveur
// par l'endpoint REST `airport-lookup` (voir Ajax_Handler), qui s'appuie sur
// Google Distance Matrix comme source de vérité. Aucun calcul de distance ou
// de décision transport n'est fait côté client.

import { Cfg } from './config.js';
import { S } from './state.js';
import { $ } from './dom.js';
import { apiGet } from './api.js';

export function applyAirportResult( ap ) {
	S.airport = ap;
	var badge = $( 'cityBadge' );
	var bText = $( 'cityBadgeText' );
	if ( ap && ap.c ) {
		if ( bText ) {
			var label  = ( S.lang === 'fr' ? 'Aéroport détecté :' : 'Airport detected:' );
			var suffix = ( ap.distanceKm != null ) ? ' — ' + ap.distanceKm + ' km' : '';
			bText.textContent = '✈ ' + label + ' ' + ap.n + ' (' + ap.c + ')' + suffix;
		}
		if ( badge ) badge.classList.add( 'on' );
		triggerFlight( ap );
	} else {
		if ( badge ) badge.classList.remove( 'on' );
		var fb = $( 'fltBox' ); if ( fb ) fb.classList.remove( 'on' );
	}
}

export function applyTransportResult( t ) {
	if ( ! t ) { applyAirportResult( null ); return; }
	if ( t.mode === 'fly' ) {
		// v1.1.30 — Inclure explicitement mode:'fly' pour que les consumers
		// (computeCurrentTravelDays, etc.) puissent détecter le transport
		// sans devoir inférer via la présence de S.airport.c.
		applyAirportResult( { c: t.c, n: t.n, distanceKm: t.distanceKm, level: t.level, mode: 'fly' } );
		return;
	}
	// Mode 'drive'
	S.airport     = { c: null, n: null, mode: 'drive', driveKm: t.driveKm, driveMinutes: t.driveMinutes || 0, haversineKm: t.haversineKm };
	S.flightCost  = 0;
	S.flightRoute = '';
	var badge = $( 'cityBadge' );
	var bText = $( 'cityBadgeText' );
	var fr    = S.lang === 'fr';
	if ( bText ) {
		var label = fr ? 'Déplacement en voiture' : 'Road trip';
		bText.textContent = '🚗 ' + label + ' — ~' + t.driveKm + ' km';
	}
	if ( badge ) badge.classList.add( 'on' );
	var fb = $( 'fltBox' ); if ( fb ) fb.classList.remove( 'on' );
}

/**
 * triggerFlight — DESACTIVE en v1.0.83 (cost control).
 *
 * Historiquement, ce helper appelait /flight-price cote frontend pour
 * afficher en live le prix du vol estime apres que l'utilisateur ait
 * entre son adresse + date. Chaque keystroke = 1 vrai call Duffel
 * (~0.01$ en credit API). Pour eviter le risque d'abuse + minimiser
 * les coûts inutiles quand un user abandonne le form, le call live a
 * ete retire — le prix du vol est calcule UNIQUEMENT au moment du
 * /submit final, cote backend, via Duffel::cheapest_roundtrip() dans
 * compute_pricing(). Le user voit le vol dans la quote finale (page
 * publique apres submission) plutot qu'en preview temps-reel.
 *
 * Pour reactiver : (1) remettre l'appel apiGet ci-dessous, (2) ajouter
 * la route REST /flight-price dans class-ajax-handler.php, (3) ajouter
 * une bot-protection sur cet endpoint avant la rate-limit.
 *
 * @param {{c: string}} ap  Airport object (ignored — no-op)
 */
export function triggerFlight( ap ) {
	// No-op : on laisse compute_pricing cote backend faire le call Duffel
	// au submit. S.flightCost reste 0 jusqu'a ce que la soumission soit
	// creee et qu'elle affiche le prix sur la page publique.
	S.flightCost  = 0;
	S.flightRoute = '';
}
